import { render, staticRenderFns } from "./SingleLayerInfos.vue?vue&type=template&id=5a90013e&scoped=true"
import script from "./SingleLayerInfos.vue?vue&type=script&lang=ts"
export * from "./SingleLayerInfos.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SingleLayerInfos.vue?vue&type=style&index=0&id=5a90013e&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5a90013e",
  null
  ,true
)

export default component.exports